import React, { Component } from 'react'

import { formatDate } from './../helper.js'
import { API_BASE_URL_DEV, API_BASE_URL_PROD } from './../config.js'

export default class Blog extends Component {
  constructor(props) {
    super(props)
    this.state = { posts: [], categories: [] }
  }

  getPosts(url) {
    fetch(url, {})
      .then(response => response.json())
      .then(json => this.setState({ posts: json }))
  }

  getPost(url) {
    fetch(url, {})
      .then(response => response.json())
      .then(json => {
        const posts = []
        posts.push(json)
        this.setState({ posts: posts })
      })
  }

  componentDidMount() {
    let url =
      (process.env.NODE_ENV === 'development'
        ? API_BASE_URL_DEV
        : API_BASE_URL_PROD) + 'posts'
    if (this.props.slug.length > 0) {
      url += '/slug=' + this.props.slug
      this.getPost(url)
    } else {
      this.getPosts(url)
    }
  }

  render() {
    return (
      <div className="blog">
        <div className="blog-title">
          Diary
          <br />
          Daniela Janjic
        </div>
        {this.state.posts
          .filter(post => {
            return (
              this.props.hash === '#alle' ||
              this.props.hash === '' ||
              post.Tags.toLowerCase().includes(this.props.hash.replace('#', ''))
            )
          })
          .map(function(post, index) {
            return (
              <div className="blog-post" key={index}>
                <div className="blog-post-title">{post.Title}</div>
                <div className="blog-post-placeanddate">
                  {post.Place.length > 0 ? (
                    <span className="blog-post-placeanddate-place">
                      {post.Place + ', '}
                    </span>
                  ) : (
                    <span />
                  )}
                  <span className="blog-post-placeanddate-date">
                    {formatDate(post.CustomDate)}
                  </span>
                </div>
                <div
                  className="blog-post-content"
                  dangerouslySetInnerHTML={{ __html: post.Content }}
                />
              </div>
            )
          })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/front/components/blog.js